/**
 * Determine the day/month order the device locale uses when rendering a
 * numeric date. Returns either `'DMY'` (day-month-year, e.g. en-GB, en-AU,
 * de-DE) or `'MDY'` (month-day-year, e.g. en-US).
 *
 * Year-first locales (en-CA "YYYY-MM-DD", ja-JP "YYYY/MM/DD") fall back to
 * `'MDY'` for input purposes. The birthday input mask is fixed at 2-2-4
 * with `/` separators, which doesn't accommodate a leading 4-digit year;
 * MD-Y is also what most web forms in those regions actually use. The BE
 * accepts `birthdayInfo: { day, month, year }` as structured data, so the
 * input ordering is purely a display concern.
 *
 * Uses `Intl.DateTimeFormat.formatToParts()` to read CLDR's ordering for
 * the device's raw `navigator.language` — same source-of-truth pattern as
 * `helpers/format/format-date.js` and `helpers/device-uses-24-hour.js`.
 * Falls back to `'MDY'` when `navigator.language` isn't a valid locale tag.
 *
 * @returns {'DMY'|'MDY'}
 */
function localeDateInputOrder() {
  try {
    const locale = window.navigator.language || 'en-US';

    const parts = new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date(Date.UTC(2026, 0, 15)));

    const order = parts
      .filter(p => p.type === 'day' || p.type === 'month' || p.type === 'year')
      .map(p => p.type);

    if (order[0] === 'day') return 'DMY';
    return 'MDY';
  }
  catch {
    return 'MDY';
  }
}



export default localeDateInputOrder;
